<div #creation_container class="container-popup">
  <div class="ui-g-12 p-0">
    <div style="margin-bottom:11px">
      <label for="channel"  class="field-label">Canale</label>
    </div>

    <app-form-fields #channel [(fieldModel)]="editFieldModel.channel" [type]="'dropdown'" [options]="listChannel"
      [name]="'channelList'"[optionLabel]="'label'" [placeholder]="'Seleziona canale...'" [required]="true"
     >
    </app-form-fields>
    <span *ngIf="missingChannel" class="danger">{{missingChannelMessage}}</span>
  </div>

  <div class="ui-g-12 p-0 mt2">
    <h2 class="title-margin">Periodo di validità della canale <i class="pi pi-info-circle"></i></h2>
  </div>

  <div class="ui-g-12 p-0">
    <div class="ui-g-6"
      *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
      <label for="start_date" class="field-label">Data di inizio</label>
      <app-form-fields #start_date [showRequiredAsterix]="true"
        [(fieldModel)]="editFieldModel.start_date" [type]="'date'" [readOnly]="false"
        (fieldModelChange)="onChangeStartDate($event)"
        required="true"
     ></app-form-fields>
     <span *ngIf="dateOrderError" class="danger">{{dateOrderMessage}}</span>
    </div>
    <div class="ui-g-6"
      *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
      <label for="end_date"  class="field-label">Data di fine</label>
      <app-form-fields #end_date [showRequiredAsterix]="true"
        [(fieldModel)]="editFieldModel.end_date" [type]="'date'" [readOnly]="false"
        (fieldModelChange)="onChangeEndDate($event)"
        required="true"></app-form-fields>
        <span *ngIf="dateOrderError" class="danger">{{dateOrderMessage}}</span>
    </div>

  </div>

  <div class="ui-g-12 p-0 mt2">
    <h2 class="title-margin">Periodo di accumulo <i class="pi pi-info-circle"></i></h2>
  </div>

  <div class="ui-g-12 p-0">
    <div class="ui-g-6"
      *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">


      <label for="date_pti_start"  class="field-label">{{ 'acm.timeStartAccum' | translate }}</label>
      <app-form-fields #date_pti_start [showRequiredAsterix]="true"
        [(fieldModel)]="editFieldModel.date_pti_start" [type]="'date'" [readOnly]="false"
        (fieldModelChange)="onChangeStartAccDate($event)"
        required="true"></app-form-fields>
        <span *ngIf="dateOrderAccError" class="danger">{{dateOrderAccMessage}}</span>

    </div>
    <div class="ui-g-6"
      *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">


      <label for="date_pti_end"  class="field-label">{{ 'acm.timeEndAccum' | translate }}</label>
      <app-form-fields #date_pti_end [showRequiredAsterix]="true"
        [(fieldModel)]="editFieldModel.date_pti_end" [type]="'date'" [readOnly]="false"
        (fieldModelChange)="onChangeEndAccDate($event)"
        required="true"></app-form-fields>
        <span *ngIf="dateOrderAccError" class="danger">{{dateOrderAccMessage}}</span>

    </div>
  </div>

  <div class="ui-g-12 p-0 mt2" style="margin-top: 26px;">

    <div class="ui-g-3">

    </div>
    <div class="ui-g-4">
      <span> Circolarità Esterna</span>
    </div>
    <div class="ui-g-2">
      <app-form-fields #flgExtCirc [(fieldModel)]="editFieldModel.flg_ext_circ" [type]="'switch'"></app-form-fields>
    </div>
    <div class="ui-g-3">

    </div>


  </div>
  <div class="ui-g-12  d-flex justify-content-center edit-btn-container">
    <button class="btn-edit-footer" (click)="onClosePopup()">{{ 'common.cancel' | translate }}</button>
    <button class="btn-edit-footer" (click)="OnSaveEntity()">{{ 'common.save' | translate }}</button>
  </div>


  <p-dialog header="Errori" [(visible)]="popupError" [styleClass]="'custom-dialog-style'">
    <div class="container-popup-content">
      <div class="error-icon-container">
        <i class="pi pi-exclamation-triangle error-icon"></i>
      </div>
      <div class="error-message">{{ 'acm.msgCorrectErr' | translate }}</div>
    </div>
  </p-dialog>




</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/acm-channel-edit-3/acm-channel-edit-3.component.html